var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 2.31983L19.2501 9.2221C19.4129 9.57025 19.7272 9.81322 20.0921 9.86951L27.3682 10.9792C27.6629 11.0206 27.9282 11.1836 28.1092 11.4325C28.4488 11.8992 28.3969 12.5599 27.9899 12.9614L22.7163 18.3451C22.4482 18.6118 22.329 19.0029 22.3991 19.3837L23.6621 26.9807C23.7505 27.6104 23.3436 28.2 22.7471 28.3022C22.5002 28.3422 22.2476 28.3007 22.023 28.1837L15.5426 24.597C15.217 24.4104 14.8269 24.4104 14.5013 24.597L7.97314 28.203C7.42726 28.4963 6.75928 28.2785 6.46178 27.7141C6.34811 27.4859 6.30882 27.2267 6.34811 26.9733L7.61109 19.3762C7.67424 18.997 7.55496 18.6074 7.29394 18.3392L1.99225 12.9569C1.56003 12.5036 1.55723 11.7658 1.98804 11.3095C2.12045 11.1232 2.41934 11.0135 2.62655 10.9747L9.90409 9.86507C10.2675 9.80433 10.5805 9.56433 10.7461 9.21618L13.9933 2.31983C14.1238 2.03983 14.3554 1.82502 14.636 1.72724C14.9181 1.62798 15.2268 1.65168 15.4921 1.79242C15.7096 1.9065 15.8878 2.09168 16.0001 2.31983Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f47ef650.svg";
export { ForwardRef as ReactComponent };